import React from 'react';
import { BsImageFill } from 'react-icons/bs';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import './SocialPreview.scss';

const SocialPreview = props => {
	const { color, display, isPad, isWeb, from, padding, margin, includeHeaders } = props;
	const fromButton = from === 'WidgetButton';
	const fromPreview = from === 'Preview';

	const renderCarousel = () => {
		const dots = new Array(10).fill('');
		const carousel = isWeb ? (
			<div className="carouselContainer">
				<div className="carouselImg sm">
					<BsImageFill style={{ fontSize: 40, color: 'white' }} />
				</div>
				<div className="carouselImg sm">
					<BsImageFill style={{ fontSize: 40, color: 'white' }} />
				</div>
				<div className="carouselImg sm">
					<BsImageFill style={{ fontSize: 40, color: 'white' }} />
				</div>
			</div>
		) : (
			<div className={isPad ? 'carouselImg pad' : 'carouselImg lg'}>
				<BsImageFill style={{ fontSize: 100, color: 'white' }} />
			</div>
		);
		return (
			<>
				{carousel}
				<div className="dotsContainer">
					{dots.map((dot, idx) => {
						return <div className="dot" key={idx}></div>;
					})}
				</div>
			</>
		);
	};

	const renderStandard = () => {
		const standardItems = fromButton || fromPreview ? new Array(1).fill('') : new Array(3).fill('');
		return isPad ? (
			<div className="standard-container-ipad">
				{standardItems.map((item, idx) => {
					return (
						<div className="standard-item" key={idx}>
							<div className="socialImg">
								<BsImageFill style={{ fontSize: 28, color: 'white' }} />
							</div>
							<div className="attendee-header">
								<Avatar icon={<UserOutlined />} style={{ marginRight: '10px' }} size="small" />
								<div className="socialItem-attendee">
									<div className="socialItem-attendee-name"></div>
									<div className="socialItem-time"></div>
								</div>
							</div>
							<div className="socialItem-body"></div>
						</div>
					);
				})}
			</div>
		) : (
			<div className="standard-container-phone">
				{standardItems.map((_, idx) => (
					<div
						className="socialItem"
						style={{
							padding,
							margin: fromButton ? 0 : fromPreview ? '6px 0' : '0.5em 0',
							cursor: fromPreview ? 'default' : 'pointer',
						}}
						key={idx}
					>
						<div
							className="socialImg"
							style={{
								height: fromButton ? '50px' : fromPreview ? '60px' : '80px',
								marginRight: fromButton ? '18px' : fromPreview ? '20px' : '30px',
							}}
						>
							<BsImageFill
								style={{ fontSize: fromButton ? 18 : fromPreview ? 22 : 28, color: 'white' }}
							/>
						</div>
						<div className="socialItem-info">
							<div
								className="socialItem-attendee"
								style={{ marginBottom: fromButton || fromPreview ? '.75em' : '1em' }}
							>
								<Avatar
									icon={<UserOutlined />}
									style={{ marginRight: '10px' }}
									size={fromButton || fromPreview ? 'small' : 'default'}
								/>
								<div className="attendee-header">
									<div
										className="socialItem-attendee-name"
										style={{
											backgroundColor: color,
											height: fromButton ? '.6em' : fromPreview ? '.7em' : '.9em',
											width: fromButton ? '4em' : '6em',
											marginBottom: fromButton || fromPreview ? '.3em' : '.5em',
										}}
									></div>
									<div
										className="socialItem-time"
										style={{
											height: fromButton || fromPreview ? '.5em' : '.6em',
											width: fromButton ? '3em' : '4em',
										}}
									></div>
								</div>
							</div>
							<div
								className="socialItem-body"
								style={{
									height: fromButton ? '.7em' : fromPreview ? '.8em' : '1em',
									marginBottom: fromButton || fromPreview ? 0 : '10px',
								}}
							></div>
						</div>
					</div>
				))}
			</div>
		);
	};
	return (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : null}>
				{!from && <div className="hover-container">Social Feed Posts</div>}
				<div className="column-container" style={{ margin }}>
					{!fromButton && includeHeaders && (
						<>
							<div className="divider">
								<div className="line" style={{ backgroundColor: color }}></div>
								<h3 style={{ color }}>Social Feed</h3>
								<div className="line" style={{ backgroundColor: color }}></div>
							</div>
							<span className="mostRecentText" style={{ color, marginBottom: '1em' }}>
								Most recent {display === 'carousel' && 'image'} social posts
							</span>
						</>
					)}
					{display === 'carousel' ? renderCarousel() : renderStandard()}
					{!fromButton && !fromPreview && (
						<p className="socialWidgetViewAllText" style={{ color }}>
							View all posts{' '}
						</p>
					)}
				</div>
			</div>
		</div>
	);
};

export default SocialPreview;
